import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
const ErrorComponent = () => {
  const navigate = useNavigate();
  useEffect(()=>{
      navigate(`/dashboard`);
  },[])
  return (
    <>
    </>
  );
};

export default ErrorComponent;